<template>
  <van-radio-group @change="selectChange" v-model="payType" class="pay">
    <div class="pay-item" @click="payType=2">
      <img src="./alipay@3x.png" alt="">
      <p>支付宝</p>
      <div style="flex: 1"></div>
      <van-radio icon-size="0.4rem" checked-color="#E1244E" :name="2" />
    </div>
    <div class="pay-item" @click="payType=1">
      <img src="./wechat@3x.png" alt="">
      <p>微信支付</p>
      <div style="flex: 1"></div>
      <van-radio icon-size="0.4rem" checked-color="#E1244E" :name="1"/>
    </div>
  </van-radio-group>
</template>

<script>
export default {
  name: 'pay-select',
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: Number
  },
  data() {
    return {
      payType: 1
    }
  },
  methods: {
    selectChange() {
      this.$emit('change', this.payType)
    }
  }
}
</script>

<style scoped lang="stylus">
  .pay
    margin-top 20px
    margin-bottom 135px
    padding 0 30px
    background-color #fff
    .pay-item
      display flex
      height 95px
      align-items center
      &>img
        width 40px
        height 40px
        margin-right 21px
      &>p
        font-size 26px
        color #000000
</style>
